import { ModalOverlay, type ModalOverlayProps } from 'react-aria-components';

import Lottie from '../lottie-player/LottiePlayer';

import { animationData } from './animation/MyStoreLoaderLeafyGreenAnimation';

const overlayStyles = {
  backgroundColor: '#FFFFFF',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
} as const;

type LoaderProps = {
  inner?: boolean;
  open?: boolean;
  testId?: string;
} & Omit<ModalOverlayProps, 'isOpen'>;

const LoaderContent = () => (
  <div
    style={{
      maxWidth: '140px',
      width: '100%',
    }}
  >
    <Lottie animationData={animationData} autoplay loop />
  </div>
);

const Loader = ({ inner = false, open = true, testId, ...others }: LoaderProps) => {
  if (!open) {
    return null;
  }

  if (inner) {
    return (
      <div
        role='status'
        aria-busy='true'
        className='loader-overlay loader-overlay--inner'
        style={{
          ...overlayStyles,
          position: 'absolute',
          inset: 0,
          zIndex: 1,
        }}
        data-testid={testId ?? 'loader'}
      >
        <LoaderContent />
      </div>
    );
  }

  return (
    <ModalOverlay
      isOpen={open}
      className='loader-overlay'
      style={{
        ...overlayStyles,
        position: 'fixed',
        inset: 0,
      }}
      data-testid={testId ?? 'loader'}
      {...others}
    >
      <LoaderContent />
    </ModalOverlay>
  );
};

export default Loader;
